module.exports = __webpack_public_path__ + "static/media/3010.89b50f73.jpg";